import React, {useEffect} from "react";
import AOS from 'aos';
// import CTAImg from "../Assets/Images/cta-fg.avif";
import { Link } from "react-router-dom";

function CTA() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      

      {/* <section className="cta py-5" data-aos="fade-up" data-aos-duration="2000">
        <div className="cta-overlay">
          <div className="container cta-content py-5">
            
              <div className="row d-flex justify-content-center align-items-center g-5">
                <div className="col-md-6 img-column">
                  <img
                    src={CTAImg}
                    alt="call-to-action"
                    className="img-fluid inner-cta"
                  />
                </div>
                <div className="col-md-6">
                  <div className="section-header">
                    <h6>Let's collaborate</h6>
                    <h2>Ready To Elevate Your Brand??</h2>
                  </div>
                  <p>
                    Contact us today and let our expert team at Farooq Graphics
                    bring your vision to life with creative precision. Your
                    brand's journey to excellence starts here.
                  </p>
                  <div className="cta-button">
                    <Link to="/contact">
                      {" "}
                      <button className="first-button">
                        Contact Us <span>&rarr;</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </section> */}

<section className="mb-5 mt-5" data-aos="fade-up" data-aos-duration="2000">
        <div className="container call-to-action">
        <div className="cta-overlay">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-10 p-5 text-center text-light">
              <div className="section-header">
              <h6>Let's collaborate</h6>
              <h2>Ready To Elevate Your Brand??</h2>
              </div>
              <p className='mb-5 text-light'>Contact us today and let our expert team at Farooq Graphics
                    bring your vision to life with creative precision. Your
                    brand's journey to excellence starts here.</p>
              <Link to="/pos-demo"><button className="second-button text-light">Get A Demo <span>&rarr;</span></button></Link>
            </div>
          </div>
        </div>
        </div>
      </section>
    </div>
  );
}

export default CTA;
